import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedContent from './components/FeaturedContent';
import TrendingRanking from './components/TrendingRanking';
import FAQSection from './components/FAQSection';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '极速高清 - 在线观看高清视频平台',
    description: '极速高清为您提供极速、高清、无广告的在线观看体验，支持手机、平板、电脑多端同步，无需下载即可立即播放影视、综艺、纪录片等海量内容。',
    url: 'https://movihubs.github.io/',
    isPartOf: {
      '@type': 'WebSite',
      name: '极速高清',
      url: 'https://movihubs.github.io',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedContent />
        <TrendingRanking />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}